import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from '../../../environment';
import { BisnodeStatus } from '../../models/bisnode-status.model';
import { CreateCompanyModel } from '../../models/create-company.model';
import { CreateWorksiteModel } from '../../models/create-worksite.model';
import { ListCompany } from '../../models/list-company.model';
import { ListWorksite } from '../../models/list-worksite.model';
import { SearchResult } from '../../models/search-result.model';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Cache-Control': 'no-cache',
    Pragma: 'no-cache',
    Expires: 'Sat, 01 Jan 2000 00:00:00 GMT',
  }),
};

@Injectable({
  providedIn: 'root',
})
export class CompanyClient {
  private http = inject(HttpClient);
  private env = inject(environment);
  private apiUrl = this.env.oregApiUrl + '/company';

  public searchCompany(
    number: string,
    country: string,
    noFilter: boolean,
  ): Observable<SearchResult<ListCompany>> {
    const url = `${this.apiUrl}/search?companyNumber=${number}&country=${country}&noFilter=${noFilter}`;

    return this.http.get<SearchResult<ListCompany>>(url, httpOptions).pipe(
      map((data) => {
        const companies = data.result.map((company) => {
          if (!company.bisnodeStatus) {
            company.bisnodeStatus = {
              name: 'Aktiv',
              code: 'ST00',
            } as BisnodeStatus;
          }
          company.worksites = company.worksites.map((worksite) => {
            if (
              worksite.identicalWorksites &&
              worksite.identicalWorksites.length > 0
            ) {
              worksite.identicalWorksites = worksite.identicalWorksites.map(
                (id) => {
                  const identicalWorksite = {} as ListWorksite;
                  identicalWorksite.providerId = id;
                  return identicalWorksite;
                },
              );
              worksite.hasIdenticalWorksites = true;
            }
            return worksite;
          });
          return company;
        });

        const result = {} as SearchResult<ListCompany>;
        result.result = companies;
        result.totalAmount = data.totalAmount;
        return result;
      }),
    );
  }

  public createCompanyAndWorksite(
    company: CreateCompanyModel,
    worksite: CreateWorksiteModel,
  ): Observable<ListWorksite> {
    const url = `${this.apiUrl}`;
    const data = JSON.stringify({
      company: company,
      worksite: worksite,
    });

    return this.http.post<ListWorksite>(url, data, httpOptions);
  }
}
